import * as firebase from "firebase";
import userLoginHelp from "@/store/userLogin/help.js";

export default {
  state: {
    user: null,
    loginTab: { text: "login", routerLink: "", icon: "mdi-login-variant" },
    avatarOptions: [
      { name: "fileManager", routerLink: "", icon: "mdi-file-document-edit" },
      { name: "logout", routerLink: "", icon: "mdi-logout-variant" },
    ],
  },
  getters: {
    user(state) {
      return state.user;
    },
    loginTab(state) {
      return state.loginTab;
    },
    avatarOptions(state) {
      return state.avatarOptions;
    }
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload;
    },
    setUserLogin(state, payload) {
      state.userLogin = payload;
    }
  },
  actions: {
    logout({ commit }) {
      commit("setLoading", true);
      firebase.auth().signOut();
      commit("setSuccessMessage", "Successfully logged out.");
      commit("setUser", null);
      commit("setLoading", false);
    },
    login({ commit }, payload) {
      commit("setLoading", true);
      firebase
        .auth()
        .signInWithEmailAndPassword(payload.email, payload.password)
        .then((userData) => {
          let loggedInUser = {
            id: userData.user.uid,
            email: userData.user.email,
          };
          loggedInUser = userLoginHelp.getUserData(loggedInUser);

          commit("setUser", loggedInUser);
          commit("setLoading", false);
          commit("setSuccessMessage", "Successfully logged in as administrator.");
        })
        .catch((error) => {
          commit("setLoading", false);
          commit("setErrorMessage", error.message);
        });
    },
    autoSignIn({ commit }, payload) {     
      let loggedInUser = {
        id: payload.uid,
        email: payload.email,
      };
      commit("setLoading", true);
      loggedInUser = userLoginHelp.getUserData(loggedInUser);
      commit("setUser", loggedInUser);
      commit("setLoading", false);
    }
  },
  modules: {}
};
